<template>
    <div class="article-container">
        <div class="article-inner-container">
            <section class="content-card">
                <h2>{{articleInfo.title}}</h2>
                <div class="article-time">{{articleInfo.sendTime}}</div>
                <div v-if="isLoading">
                    <a-skeleton active />
                    <a-skeleton active />
                    <a-skeleton active />
                </div>
                <div v-else v-html="articleInfo.content"></div>
            </section>
        </div>
    </div>
</template>


<script>
    import {articleDetail} from "@api/article";
    import {showError} from "@utils/msg";

    export default {
        data() {
            return {
                articleInfo: {},
                isLoading: true
            }
        },
        created() {
            articleDetail(this.$route.params.id).then(res => {
                this.isLoading = false;
                if (res.code === 0) {
                    this.articleInfo = res.data;
                  this.articleInfo.content = this.articleInfo.content.replaceAll('src="/profile/', 'src="/api/profile/')
                } else {
                    showError("加载文章数据失败", res.msg)
                }
            })
        }

    }
</script>

<style scoped lang="less">
    @import '../../styles/variable.less';

    .article-container {
        background-color: #F4F4F4;
        padding: 20px 20px 40px;
    }

    .article-inner-container {
        max-width: 1200px;
        margin: 0 auto;

        /deep/ img {
            max-width: 100% !important;
        }

        h2 {
            min-height: 40px;
            text-align: center;
        }

        .article-time {
            text-align: center;
            padding: 0 20px 10px;
            color: #999;
        }

        .content-card {
            padding: 20px;
            background-color: white;
        }
    }

    @media screen and (max-width: @screen-lg) {
        .article-container {
            padding: 10px 10px 20px;
        }
    }

</style>
